import React, { useEffect, useRef } from 'react';
import SearchView from "./search.view";
import { ISearch, IState } from "./types/search-engine.types";
import { useBaseComponent } from "../../base/base-component";
import { useSearch } from "./components/use-search";
import { useNavigate } from "react-router-dom";
import { InputRef } from "antd";
import "../../styles/component/search.scss";


const Search: React.FC = () => {

    const inputRef = useRef<InputRef>(null);
    const resultRef = useRef<HTMLDivElement>(null);
    const {search} = useSearch();
    const navigate = useNavigate();

    const {state, updateState} = useBaseComponent<{}, IState>({}, {
        initialState: () => ({
            data: [],
            internal: {
                showResult: false,
                query: '',
                searchResult: {
                    quickLinks: [],
                    results: []
                }
            }

        }),
    });
    const [activeIndex, setActiveIndex] = React.useState<number>(-1);
    const allItems = [
        ...state.internal.searchResult.results,
        ...state.internal.searchResult.quickLinks
    ];

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            const target = event.target as Node;

            if (
                inputRef.current &&
                !inputRef.current.input?.contains(target) &&
                resultRef.current &&
                !resultRef.current.contains(target)
            ) {
                updateState('internal.showResult', false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    async function onSearch(val: string) {
        const results = search(val);
        updateState('internal', {
            showResult: true,
            query: val,
            searchResult: results
        });
    }

    function handleNavigation(route: string) {
        updateState('internal', {
            ...state.internal,
            showResult: false,
            query: ''
        });

        navigate(route);
    }

    function onInputClick() {
        const results = search('');
        updateState('internal', {
            showResult: true,
            query: '',
            searchResult: results
        });
    }

    function handleKeyNavigation(e: React.KeyboardEvent) {
        if (!state.internal.showResult || allItems.length === 0) return;

        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                setActiveIndex(prev =>
                    prev < allItems.length - 1 ? prev + 1 : 0
                );
                break;

            case 'ArrowUp':
                e.preventDefault();
                setActiveIndex(prev =>
                    prev > 0 ? prev - 1 : allItems.length - 1
                );
                break;

            case 'Enter':
                if (activeIndex >= 0) {
                    handleNavigation(allItems[activeIndex].route);
                }
                break;

            case 'Escape':
                updateState('internal.showResult', false);
                setActiveIndex(-1);
                break;
        }
    }

    return (
        <SearchView
            inputRef={inputRef}
            resultRef={resultRef}
            searchQuery={state.internal.query}
            searchResult={state.internal.searchResult}
            onSearch={onSearch}
            showResult={state.internal.showResult}
            handleNavigation={handleNavigation}
            onInputClick={onInputClick}
            onKeyDown={handleKeyNavigation}
            activeIndex={activeIndex}
        />
    )
}

export default Search;
